import useDocumentStore from "@/stores/document";
import { useUIStore } from "../../stores/ui";

export default async function dataSubmission({ to, next }) {
  let submissions = useDocumentStore().selectedSubmission;
  if (to.query.signing) {
    if (Object.keys(submissions).length > 0) {
      // console.log("redirect open document");
      useUIStore().layout = "layout-admin";
      return next();
    } else {
      // console.log("redirect need sign");
      return next({
        name: "needSignElectronic",
      });
    }
  } else {
    useUIStore().layout = "layout-admin";
    return next();
  }
}
